enum Integrations {
  NO_INTEGRATION = 'NO_INTEGRATION',
  GA_VISITOR_HOMEPAGE = 'GA_VISITOR_HOMEPAGE',
  ALL_NON_INTERNAL_USERS = 'ALL_NON_INTERNAL_USERS'
}

export default Integrations
